import axios from '@/plugins/axios-instance.js'
import appSync from '@/_services/appsync.service.js'
import gql from 'graphql-tag'
import { uuid } from 'vue-uuid'

export const vehicleService = {
  setVehicle,
  listVehicles,
  listVehicleClasses,
  createVehicle,
  createVehicleClass,
  removeVehicle,
  setVehiclePlateNumber,
  setVehicleVehicleLimits,
  setVehicleLoadArea,
  setVehicleTrailer,
  setVehicleEquipment,
  setVehiclePrice,
  setVehicleLabels,
  setVehicleName,
  setVehicleModel,
  setVehicleDepot,
  setVehicleType,
  setVehicleCount,
  getVehicle,
  getVehicleClass,
  getCurrencyEnum,
  getRestrictionsEnum,
  getVehicleTypeEnum,
  getVehiclePriceTypeEnum,
  getVehicleEquipmentEnum
}

let url = 'https://q53gya9zol.execute-api.eu-west-1.amazonaws.com/prod/vehicles/'

function setVehicle (vehicleData) {
  return axios.post(url, { body: vehicleData })
}

//** Queries */
const LIST_VEHICLES = gql`query listVehicles($input: ListVehiclesInput!) {
  listVehicles (input: $input) {
    vehicles {
      id
      name
      model
      labels
      plateNumber
      type
      depot {
        id
        ref
        name
        address {
          street
          streetNo
          city
          country
          countryCode
          postalCode
        }
      }
      organization {
        id
        name
        ref
      }
      vehicleLimits {
        maxWeight
        width
        height
        length
      }
      loadArea {
        maxWeight
        width
        height
        length
      }
      trailer {
        maxWeight
        width
        height
        length
      }
      pricePerEmptyKM {
        price
        currency
      }
      pricePerFullKM {
        price
        currency
      }
      minimalPrice {
        price
        currency
      }
      equipment
    }
  }
}`
const LIST_VEHICLE_CLASSES = gql `query listVehicleClasses($input: ListVehicleClassesInput!) {
  listVehicleClasses (input: $input) {
    vehicleClasses {
      id
      organization {
        id
        name
        ref
      }
      count
      type
      equipment
      vehicleLimits {
        height
        length
        width
        maxWeight
      }
      depot {
        id
        ref
        name
        address {
          street
          streetNo
          city
          country
          countryCode
          postalCode
        }
      }
      pricePerEmptyKM {
        price
        currency
      }
      pricePerFullKM {
        price
        currency
      }
      minimalPrice {
        price
        currency
      }
    }
  }
}`

const GET_VEHICLE = gql`query getVehicle($input: GetVehicleInput!) {
  getVehicle (input: $input) {
    vehicle {
      id
      name
      model
      labels
      maxWeight
      maxVolume
      depot {
        id
      }
      organization {
        ref
        name
      }
      type
      plateNumber
      loadArea {
        height
        length
        maxWeight
        width
      }
      vehicleLimits {
        maxWeight
        width
        height
        length
      }
      pricePerEmptyKM {
        price
        currency
      }
      pricePerFullKM {
        price
        currency
      }
      minimalPrice {
        price
        currency
      }
    }
  }
}`
const GET_VEHICLE_CLASS = gql`query getVehicleClass($input: GetVehicleClassInput!) {
  getVehicleClass (input: $input) {
    vehicleClass {
      type
      organization {
        ref
        name
      }
      depot {
        id
      }
      vehicleLimits {
        maxWeight
        width
        height
        length
      }
    }
  }
}`

async function listVehicles ({ organizationID }) {
  try {
    const response = await appSync.query({
      query: LIST_VEHICLES,
      variables: {
        input: {
          organizationID
        }
      }
    })
    if (response.data.listVehicles.vehicles != null) {
      return response.data.listVehicles.vehicles
    } else {
      return []
    }
  } catch (error) {
    return Promise.reject(error)
  }
}

async function listVehicleClasses ({ organizationID }) {
  try {
    const response = await appSync.query({
      query: LIST_VEHICLE_CLASSES,
      variables: {
        input: {
          organizationID
        }
      }
    })
    if (response.data.listVehicleClasses.vehicleClasses != null) {
      return response.data.listVehicleClasses.vehicleClasses
    } else {
      return []
    }
  } catch (error) {
    return Promise.reject(error)
  }
}

async function getVehicle ({ vehicleID }) {
  try {
    const response = await appSync.query({
      query: GET_VEHICLE,
      variables: {
        input: {
          id: vehicleID
        }
      }
    })
    return response.data.getVehicle.vehicle
  } catch (error) {
    return Promise.reject(error)
  }
}
async function getVehicleClass ({ vehicleClassID }) {
  try {
    const response = await appSync.query({
      query: GET_VEHICLE_CLASS,
      variables: {
        input: {
          id: vehicleClassID
        }
      }
    })
    return response.data.getVehicleClass.vehicleClass
  } catch (error) {
    return Promise.reject(error)
  }
}

//** Mutations */

const CREATE_VEHICLE = gql`mutation createVehicle ($input: CreateVehicleInput!) {
  createVehicle(input: $input) {
    id
  }
}`
const CREATE_VEHICLE_CLASS = gql`mutation createVehicleClass($input: CreateVehicleClassInput!) {
  createVehicleClass(input: $input) {
    id
  }
}`

const SET_NAME = gql`mutation setName($input: SetNameInput!) {
  setName(input: $input) {
    err
  }
}`
const SET_MODEL = gql`mutation setModel($input: SetModelInput!) {
  setModel(input: $input) {
    err
  }
}`
const SET_PLATE_NUMBER = gql`mutation setPlateNumber($input: SetPlateNumberInput!) {
  setPlateNumber(input: $input) {
    err
  }
}`
const SET_VEHICLE_LIMITS = gql`mutation setVehicleLimits($input: SetVehicleLimitsInput!) {
  setVehicleLimits(input: $input) {
    err
  }
}`
const SET_LOAD_AREA_LIMITS = gql`mutation setLoadAreaLimits($input: SetLoadAreaLimitsInput!) {
  setLoadAreaLimits(input: $input) {
    err
  }
}`
const SET_TRAILER_LIMITS = gql`mutation setTrailerLimits($input: SetTrailerLimitsInput!) {
  setTrailerLimits(input: $input) {
    err
  }
}`
const SET_LABELS = gql`mutation setLabels($input: SetLabelsInput!) {
  setLabels(input: $input) {
    err
  }
}`
const SET_PRICE_PER_KM = gql`mutation setVehiclePrice($input: SetVehiclePriceInput!) {
  setVehiclePrice(input: $input) {
    err
  }
}`
const SET_VEHICLE_EQUIPMENT = gql`mutation setEquipment($input: SetEquipmentInput!) {
  setEquipment(input: $input) {
    err
  }
}`
const SET_VEHICLE_DEPOT = gql`mutation setDrop($input: SetDepotInput!) {
  setDepot(input: $input) {
    err
  }
}`
const REMOVE_VEHICLE = gql`mutation removeVehicle($input: RemoveVehicleInput!) {
  removeVehicle(input: $input) {
    err
  }
}`
const SET_VEHICLE_TYPE = gql`mutation setType($input: SetTypeInput!) {
  setType(input: $input) {
    err
  }
}`
const SET_VEHICLE_CLASS_COUNT = gql`mutation setCount($input: SetCountInput!) {
  setCount(input: $input) {
    err
  }
}`

async function createVehicle ({ organizationID, name, type, vehicleLength, vehicleHeight, vehicleWidth, vehicleMaxWeight, pricePerEmptyKM, currencyEmptyKM, plateNumber }) {
  try {
    const response = await appSync.mutate({
      mutation: CREATE_VEHICLE,
      variables: {
        input: {
          organizationID,
          name,
          type,
          vehicleLength,
          vehicleHeight,
          vehicleWidth,
          vehicleMaxWeight,
          plateNumber,
          pricePerEmptyKM,
          currencyEmptyKM
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response.data.createVehicle
  } catch (error) {
    return Promise.reject(error)
  }
}
async function createVehicleClass ({ organizationID, count, type, equipment, pricePerEmptyKM, currencyEmptyKM, pricePerFullKM, currencyFullKM, minimalPrice, minimalCurrency }) {
  try {
    const response = await appSync.mutate({
      mutation: CREATE_VEHICLE_CLASS,
      variables: {
        input: {
          organizationID,
          count,
          type,
          equipment,
          pricePerFullKM,
          currencyFullKM,
          minimalPrice,
          minimalCurrency,
          pricePerEmptyKM,
          currencyEmptyKM
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response.data.createVehicleClass
  } catch (error) {
    return Promise.reject(error)
  }
}
async function setVehicleName ({ vehicleID, name }) {
  try {
    const response = await appSync.mutate ({
      mutation: SET_NAME,
      variables: {
        input: {
          id: vehicleID,
          name
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response
  } catch (error) {
    return Promise.reject(error)
  }
}
async function setVehiclePrice ({ vehicleID, pricePerKM }) {
  try {
    const { price, currency, type } = pricePerKM
    const response = await appSync.mutate ({
      mutation: SET_PRICE_PER_KM,
      variables: {
        input: {
          id: vehicleID,
          price,
          currency,
          type
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response
  } catch (error) {
    return Promise.reject(error)
  }
}
async function setVehiclePlateNumber ({ vehicleID, plateNumber }) {
  try {
    const response = await appSync.mutate ({
      mutation: SET_PLATE_NUMBER,
      variables: {
        input: {
          id: vehicleID,
          plateNumber
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response
  } catch (error) {
    return Promise.reject(error)
  }
}
async function setVehicleVehicleLimits ({ vehicleID, vehicleLimits }) {
  try {
    const { height, width, length, maxWeight } = vehicleLimits
    const response = await appSync.mutate ({
      mutation: SET_VEHICLE_LIMITS,
      variables: {
        input: {
          id: vehicleID,
          height: parseInt(height),
          width: parseInt(width),
          length: parseInt(length),
          maxWeight: parseInt(maxWeight)
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response
  } catch (error) {
    return Promise.reject(error)
  }
}
async function setVehicleLoadArea ({  vehicleID, loadArea }) {
  try {
    const { height, width, length, maxWeight } = loadArea
    const response = await appSync.mutate ({
      mutation: SET_LOAD_AREA_LIMITS,
      variables: {
        input: {
          id: vehicleID,
          height,
          width,
          length,
          maxWeight
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response
  } catch (error) {
    return Promise.reject(error)
  }
}
async function setVehicleTrailer ({  vehicleID, trailer }) {
  try {
    const { height, width, length, maxWeight } = trailer
    const response = await appSync.mutate ({
      mutation: SET_TRAILER_LIMITS,
      variables: {
        input: {
          id: vehicleID,
          height,
          width,
          length,
          maxWeight
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response
  } catch (error) {
    return Promise.reject(error)
  }
}
async function setVehicleEquipment ({ vehicleID, add, remove }) {
  try {
    const response = await appSync.mutate ({
      mutation: SET_VEHICLE_EQUIPMENT,
      variables: {
        input: {
          id: vehicleID,
          add,
          remove
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response
  } catch (error) {
    return Promise.reject(error)
  }
}
async function setVehicleLabels ({ vehicleID, add, remove }) {
  try {
    const response = await appSync.mutate ({
      mutation: SET_LABELS,
      variables: {
        input: {
          id: vehicleID,
          add,
          remove
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response
  } catch (error) {
    return Promise.reject(error)
  }
}
async function setVehicleModel ({ vehicleID, model }) {
  try {
    const response = await appSync.mutate ({
      mutation: SET_MODEL,
      variables: {
        input: {
          id: vehicleID,
          model
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response
  } catch (error) {
    return Promise.reject(error)
  }
}
async function setVehicleDepot ({ vehicleID, depotID }) {
  try {
    const response = await appSync.mutate ({
      mutation: SET_VEHICLE_DEPOT,
      variables: {
        input: {
          id: vehicleID,
          depotID
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response
  } catch (error) {
    return Promise.reject(error)
  }
}
async function removeVehicle ({ vehicleID }) {
  try {
    const response = await appSync.mutate ({
      mutation: REMOVE_VEHICLE,
      variables: {
        input: {
          id: vehicleID
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response
  } catch (error) {
    return Promise.reject(error)
  }
}
async function setVehicleType ({ vehicleID, type }) {
  try {
    const response = await appSync.mutate ({
      mutation: SET_VEHICLE_TYPE,
      variables: {
        input: {
          id: vehicleID,
          type
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response
  } catch (error) {
    return Promise.reject(error)
  }
}

async function setVehicleCount ({ vehicleID, count }) {
  try {
    const response = await appSync.mutate ({
      mutation: SET_VEHICLE_CLASS_COUNT,
      variables: {
        input: {
          id: vehicleID,
          count
        }
      },
      fetchPolicy: 'no-cache'
    })
    return response
  } catch (error) {
    return Promise.reject(error)
  }
}

//** ENUM */

const GET_CURRENCY_TYPE_ENUMS = gql`query {
  __type(name: "Currency") {
     name
     enumValues {
       name
     }
   }
 }`

const GET_RESTRICTIONS_TYPE_ENUMS = gql`query {
  __type(name: "VehicleEquipment") {
     name
     enumValues {
       name
     }
   }
 }`

 const GET_VEHICLE_EQUIPMENT_ENUMS = gql`query {
   __type(name: "VehicleEquipment") {
     name
     enumValues {
       name
     }
   }
 }`

const GET_VEHICLE_PRICE_TYPE_ENUMS = gql`query {
  __type(name: "VehiclePriceType") {
     name
     enumValues {
       name
     }
   }
 }`
 const GET_VEHICLE_TYPE_ENUMS = gql`query {
  __type(name: "VehicleType") {
     name
     enumValues {
       name
     }
   }
 }`
async function getCurrencyEnum () {
  try {
    const response = await appSync.query({
      query: GET_CURRENCY_TYPE_ENUMS,
      fetchPolicy: 'cache'
    })
    return response.data.__type.enumValues
  } catch (error) {
    return Promise.reject(error)
  }
}
async function getRestrictionsEnum () {
  try {
    const response = await appSync.query({
      query: GET_RESTRICTIONS_TYPE_ENUMS,
      fetchPolicy: 'cache'
    })
    return response.data.__type.enumValues
  } catch (error) {
    return Promise.reject(error)
  }
}

async function getVehicleTypeEnum () {
  try {
    const response = await appSync.query({
      query: GET_VEHICLE_TYPE_ENUMS,
      fetchPolicy: 'cache'
    })
    return response.data.__type.enumValues
  } catch (error) {
    return Promise.reject(error)
  }
}

async function getVehiclePriceTypeEnum () {
  try {
    const response = await appSync.query({
      query: GET_VEHICLE_PRICE_TYPE_ENUMS,
      fetchPolicy: 'cache'
    })
    return response.data.__type.enumValues
  } catch (error) {
    return Promise.reject(error)
  }
}

async function getVehicleEquipmentEnum () {
  try {
    const response = await appSync.query({
      query: GET_VEHICLE_EQUIPMENT_ENUMS,
      fetchPolicy: 'cache'
    })
    return response.data.__type.enumValues
  } catch (error) {
    return Promise.reject(error)
  }
}
